const BAPTISM = "baptism";
const CONFIRMATION = "confirmation";
const FIRST_COMMUNION = "firstCommunion";
const FIRST_RECONCILIATION = "firstReconciliation";
const HOLY_ORDERS = "holyOrders";
const MARRIAGE = "marriage";
const DEATH_REGISTER = "deathRegister";
const SACRAMENTS = [
  BAPTISM,
  CONFIRMATION,
  FIRST_COMMUNION,
  FIRST_RECONCILIATION,
  HOLY_ORDERS,
  MARRIAGE,
  DEATH_REGISTER,
];
const BAPTISM_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING = "BaptismDate";
const CONFIRMATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING = "ConfirmationDate";
const FIRST_COMMUNION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING =
  "FirstCommunionDate";
const FIRST_RECONCILIATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING =
  "FirstReconciliationDate";
const HOLY_ORDERS_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING = "HolyOrdersDate";
const MARRIAGE_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING = "MarriageDate";
const DEATH_REGISTER_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING = "DeathRegisterDate";
export {
  BAPTISM,
  BAPTISM_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  CONFIRMATION,
  CONFIRMATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  FIRST_COMMUNION,
  FIRST_COMMUNION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  FIRST_RECONCILIATION,
  FIRST_RECONCILIATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  HOLY_ORDERS,
  HOLY_ORDERS_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  MARRIAGE,
  MARRIAGE_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  DEATH_REGISTER,
  DEATH_REGISTER_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  SACRAMENTS,
};
